import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiFigma,
  SiVercel,
  SiNetlify,
  SiGithub,
  SiDocker,
  SiNpm,
  SiYarn,
  SiWebpack,
  SiVite,
  SiJira,
  SiNotion,
  SiTrello,
} from "react-icons/si";
import { DiGit } from "react-icons/di";
import { FaServer, FaTerminal } from "react-icons/fa";

const getToolIconByName = (iconName) => {
  const iconMap = {
    vscode: SiVisualstudiocode,
    postman: SiPostman,
    slack: SiSlack,
    figma: SiFigma,
    git: DiGit,
    github: SiGithub,
    docker: SiDocker,
    vercel: SiVercel,
    netlify: SiNetlify,
    npm: SiNpm,
    yarn: SiYarn,
    webpack: SiWebpack,
    vite: SiVite,
    jira: SiJira,
    notion: SiNotion,
    trello: SiTrello,
    terminal: FaTerminal,
    server: FaServer,
  };

  return iconMap[iconName?.toLowerCase()] || SiVisualstudiocode;
};

function Toolstack({ skills }) {
  if (!skills || skills.length === 0) {
    return (
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <p className="text-white">Add your tools in the Admin Panel.</p>
      </Row>
    );
  }

  return (
    <Row
      style={{ justifyContent: "center", paddingBottom: "50px", gap: "20px" }}
    >
      {skills.map((skill) => {
        const IconComponent = getToolIconByName(skill.icon);
        return (
          <Col
            xs={5}
            sm={4}
            md={2}
            lg={2}
            className="tech-icons text-center"
            key={skill._id}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
              margin: "10px",
              borderRadius: "15px",
              background: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(199, 112, 240, 0.2)",
              transition: "all 0.3s ease",
              minHeight: "140px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.borderColor = "#c770f0";
              e.currentTarget.style.boxShadow =
                "0 8px 20px rgba(199, 112, 240, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.borderColor = "rgba(199, 112, 240, 0.2)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <IconComponent style={{ fontSize: "3.5rem", color: "#c770f0" }} />
            <div
              className="tech-icons-text"
              style={{
                marginTop: "12px",
                textAlign: "center",
                fontSize: "0.95rem",
                fontWeight: "600",
                color: "#fff",
              }}
            >
              {skill.name}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default Toolstack;
